import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../services/data.service';
import { URL_IMG } from '../../../constants/general';

@Component({
  selector: 'app-header-steps',
  templateUrl: './header-steps.component.html',
  styleUrls: ['./header-steps.component.scss']
})
export class HeaderStepsComponent implements OnInit {

  stepSession:string;
  step:number;
  url_img = URL_IMG;
  constructor(private data:DataService) { 
    
  }

  ngOnInit(): void {
    this.stepSession = this.data.getStep();
    console.log(this.stepSession);
    switch(this.stepSession) {
      case 'opciones/autonomo-identificacion':
        this.step=1;
      break;
      case 'opciones/autonomo-comprobante':
        this.step=1;
      break;
      case 'opciones/autonomo-completa-informacion':
        this.step=2;
      break;
      case 'opciones/autonomo-beneficiario':
        this.step=2;
      break;
      case 'opciones/autonomo-confirmacion':
        this.step=3;
      break;
      default:
        this.step=0;
      break;
    }
  }

}
